import { Helmet } from 'react-helmet';

/**
 * Injects JSON-LD structured data for SEO and AI discoverability.
 * Use with schema.org types: GolfCourse, Person, Organization, ItemList, FAQPage, etc.
 */
function JsonLd({ data }) {
  if (!data) return null;
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}

export default JsonLd;
